app.factory('AjaxRequestInterceptor', function ($rootScope, $q, $window, $injector, messenger, lodash, $location) {
    return {
        request: function (config) {
            config.headers = config.headers || {};
            const token = config.token || $window.localStorage.getItem('token');
            if (token) {
                config.headers.Authorization = 'Bearer ' + token;
                const chainIdService = $injector.get('chainIdService');
                config.headers['X-Request-Chain-ID'] = chainIdService.generateChainId(token);
            }

            return config;
        },
        response: function (response) {
            return response || $q.when(response);
        },
        responseError: function (response) {
            if (response.status === 401) {
                if ($window.location.href.indexOf('login?destination') > -1) {
                    $rootScope.$broadcast('loginLoading');
                }

                var $state = $injector.get('$state');

                // If already on the login page, the controller handles bad credentials — don't redirect
                if ($state.current && $state.current.name && $state.current.name.indexOf('login') === 0) {
                    return $q.reject(response);
                }

                $injector.get('$uibModalStack').dismissAll();
                $injector.get('userManager').logout();

                /**
                 * $location.search() doesn't work properly without html5Mode
                 * Don't want to play with html5Mode right now, since it means updating nginx FE server block, etc
                 * If destination is already set (bad credentials on login), leave alone.
                 * If not, set to the current/previous route
                 */
                var existingDestination = /destination=([^&]*)/g.exec($window.location.hash);
                var dest = existingDestination ? decodeURIComponent(existingDestination[1]) : $location.url().encode();

                $state.go('login.step1', { destination: dest });
            } else if (
                response.status === 409 ||
                response.status === 400 ||
                response.status === 403 ||
                response.status === 500
            ) {
                angular.element('i.loading-spinner').removeClass('fa-spinner fa-pulse');

                if (response.data) {
                    lodash.each(response.data, function(error) {
                        if (error.exception && error.exception.length) {
                            lodash.each(error.exception, function(exception) {
                                if (exception.message) {
                                    messenger.error(exception.message);
                                }
                            });
                        } else {
                            if (error.property_path && typeof error.message === 'string') {
                                messenger.error(error.message, {path: error.property_path});
                            } else if (typeof error.message === 'string') {
                                messenger.error(error.message, error.data || {});
                            } else {
                                for(var key in error.message) {
                                    messenger.error(error.message[key]);
                                }
                            }
                        }
                    });
                } else {
                    messenger.error('THIS_ENTITY_HAS_DEPENDENCIES');
                }
            } else {
                if (response.xhrStatus !== 'abort') {
                    messenger.error('REQUEST_ERROR');
                }
            }

            return $q.reject(response);
        }
    };
});

app.config(function ($httpProvider) {
    $httpProvider.interceptors.push('AjaxRequestInterceptor');
});
